import React, { useState, useEffect } from 'react';
import './authenticationBox.scss';
import { changeLanguage } from '../../../actions/language';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { Button, Input, Tooltip } from '../../../component';
import { isTripord } from '../../../utils/consts/general';
import { numberWithCommas } from '../../../utils/consts';
import { fileHandlerUrl } from '../../../utils/consts/server';
import TripordLogo from '../../../content/images/icon/tripord-logo.webp';
import TripsiLogo from '../../../content/images/icon/tripsi-logo.webp';

const AuthenticationBox = ({ language }) => {
  const { direction } = language;
  const urlLocation = window.location.origin;

  return (
    <div
      className={`AuthenticationBox d-flex w-100 p-5 text-white ${direction}`}
    >
      <div className="w-100 glass d-flex flex-column align-items-center justify-content-center default-border-radius">
        <div className="d-flex  pt-2 px-0 justify-content-center  flex-column align-items-center  ">
          <img
            width="352"
            height="176"
            src={urlLocation.includes('tripord') ? TripordLogo : TripsiLogo}
            alt={`${
              urlLocation.includes('tripord') ? 'tripord logo' : 'tripsi logo'
            }`}
          />
        </div>
        <div className="d-flex  flex-column align-items-center text-center text-white">
          <FormattedMessage
            id={
              urlLocation.includes('tripord')
                ? 'booking.welcometripord'
                : 'booking.welcometripsi'
            }
            children={(msg) => <h2 className="pb-2">{msg} </h2>}
          />
          <FormattedMessage
            id="authentication.slugone"
            children={(msg) => <h6>{msg} </h6>}
          />
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
// updateUser,
export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(withRouter(AuthenticationBox)),
);
